import { useQuery, UseQueryOptions } from "react-query";
import {
    IWritingIssuesCount,
    IWritingIssuesCountGetResponse,
    IWritingIssuesGetQueryParameters,
    Route,
} from "@edgetier/watchtower-types";
import { AxiosError } from "axios";
import { axios } from "utilities/axios";

/**
 * Request writing issues counts from the backend.
 * @param url             The URL of the request.
 * @param queryParameters Any query parameters to be sent with the request.
 * @returns An array of writing issues counts.
 */
const requestWritingIssuesCounts = async (url: string, queryParameters: {}) => {
    const { data } = await axios.get<IWritingIssuesCountGetResponse<any>>(url, {
        params: queryParameters,
    });
    return data.items;
};

/**
 * A query to get writing issues counts from the backend.
 * @param queryParameters Optional query parameters to send with the request.
 * @param options         Query options.
 */
const useWritingIssuesCounts = <T = IWritingIssuesCount<any>[]>(
    queryParameters: IWritingIssuesGetQueryParameters = {},
    options: Omit<UseQueryOptions<IWritingIssuesCount<any>[], AxiosError, T>, "queryKey" | "queryFn"> = {}
) => {
    const url = Route.WritingIssuesCounts;
    return useQuery<IWritingIssuesCount<any>[], AxiosError, T>(
        [url, queryParameters],
        () => requestWritingIssuesCounts(url, queryParameters),
        options
    );
};

export default useWritingIssuesCounts;
